import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({

    item: {
        display: 'flex',
        alignItems: 'center',
        padding: '6px 16px',
        borderRadius: '8px',
        transition: 'all 0.3s ease',
        paddingLeft: 0,
        '& > img': {
            width: 40,
            height: 40,
            marginRight: 16,
            [theme.breakpoints.up('lg')]: {
                marginRight: 20
            }
        },
        '& > span': {
            fontSize: 20,
            fontWeight: 600,
            color: '#D1D5DB',
            [theme.breakpoints.up('md')]: {
                lineHeight: '32px',
            }
        },
        '&:not(:first-child)': {
            marginTop: 20,
            [theme.breakpoints.down('md')]: {
                marginTop: 20,
            }
        },
        '&:hover': {
            '& > span': {
                color: '#fff',
            }
        },
        [theme.breakpoints.down('md')]: {
            paddingTop: 0,
            paddingBottom: 0,
            '& > span': {
                fontSize: 18,
            },
            '& > img': {
                width: 32,
                height: 32,
            }
        }
    },
    activeItem: {
        '& > span': {
            fontWeight: '600',
            color: '#fff',
        }
    },
}))

const ChecklistItem = ({ item, index, currentSlide, handleContentClick }) => {
    const classes = useStyles();
    return (

        <div
            className={`${classes.item} ${currentSlide === index ? classes.activeItem : ''}`}
            key={index}
            onClick={() => handleContentClick(index)}
            style={{ cursor: 'pointer' }}
        >
            <img src={"/static/checklist_blue.png"} alt="check" />
            {/* <img src={"/static/images/mfs/checklist.png"} alt="check" /> */}
            <span>{item}</span>
        </div>
    )
}

export default ChecklistItem;